module.exports = __webpack_public_path__ + "static/media/1.e2170bf0.jpeg";